import i18n from '@dms/i18n';

import {Field} from './primitives/Field';

export function FeaturesByManufacturerTextarea() {
  return (
    <Field
      type="textarea"
      name="featuresByManufacturer"
      minRows={3}
      label={i18n.t('entity.vehicle.labels.featuresByManufacturer')}
    />
  );
}
